var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"indexREGOP_div"}},[_c('menusuperior',{attrs:{"titulo":"REGOP","subtitulo":"Herramienta para registrar las solicitudes de ordenes de protección"}}),_vm._v(" "),_c('div',{staticClass:"content-area content-area__firma-multiple"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89c202d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/REGOP/Comun/Plantilla.vue
// module id = null
// module chunks = 